'use client';

import { Box, Divider, Stack, Typography } from '@mui/material';
import type { PropsWithChildren } from 'react';

import { EONLogo } from '@/components/layout/shared/eonLogo';

export const BlankLayout = ({ children }: PropsWithChildren) => {
  return (
    <Box className='h-full flex flex-col relative bg-(--mui-palette-background-pageGradient)'>
      {children}
      <Box className='absolute top-0 left-0 flex content-center p-[min(100px,6vw)]'>
        <EONLogo dark />
      </Box>
      <Stack
        className='absolute bottom-0 left-0 p-[min(100px,4vw)]'
        direction='row'
        gap='12px'
        divider={<Divider orientation='vertical' flexItem variant='middle' />}
      >
        <Typography>{`© ${new Date().getFullYear()} Eon. All rights reserved.`}</Typography>
        <a
          href='https://www.eon.io/about'
          target='_blank'
          rel='noreferrer'
          className='flex content-center'
        >
          About Eon
          <i className='material-symbols-open-in-new w-[20px] h-[20px] ml-[8px]'></i>
        </a>
      </Stack>
    </Box>
  );
};
